import { NgForm } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Combobox, DetailComponent, NotificationService, PMVAuthenticationService, SelectItem } from "pmv-common";
import { RouteNavigationService } from "../../../services/api/route-navigation.service";
import { ListaService } from "../../../services/lista.service";
import { ActivatedRoute } from '@angular/router';
import { Inscricao } from "../../../models/inscricao-model";
import { Lista } from "../../../models/lista.model";
import { DadosAcumuloCargo } from "../../../models/dadosAcumuloCargo.model";
import { ConvocacaoService } from "../../../services/convocacao.service";

@Component({
    selector: 'pmv-declaracaoAcumuloCargo',
    templateUrl: './declaracaoAcumuloCargo.component.html',
    styleUrls: ['./declaracaoAcumuloCargo.component.scss']
})

export class DeclaracaoAcumuloCargoComponent extends DetailComponent implements OnInit {

    editalAnoPss: string;    
    subtitle: string = 'Preencha todos os dados solicitados para continuar com o processo de admissão.';
    cpfCandidato: string;
    nomeCandidato: string;
    escalaPlantaoP1: string;
    escalaPlantaoP2: string;
    cargoFuncaoCandidato: string;
    
    inscricao: Inscricao;
    dadosAcumulo: DadosAcumuloCargo;

    valorAposentadoriaInvalidez: number;
    valorTrabalhaEscalaPlantao: number;
    valorEstaLicencaDisponibilidade: number;
    valorEstaAposentado: number;

    loading: Boolean = true;
    mostrarDadosAcumulo: Boolean = false;
    campoConfirmaNaoExerce: boolean = false;
    campoConfirmaExerce: boolean = false;
    desabilitarNaoExerce: boolean = false;
    desabilitarExerce: boolean = false;
    desabilitarCamposExerce: boolean = true;
    confirmarExerceComercio: boolean = true;
    desabilitarEstaDeLicenca: boolean = false;
    desabilitarDescricaoEscalaPlantao: boolean = true;
    desabilitaCargoEhNomeOrgaoLicenca: boolean = true;
    desabilitarCamposAposentadoria: boolean = true;
    campoDeclaraConhecimento: boolean = false;
    campoExerceComercio: boolean = false;
    mostarCamposExerceCargo: boolean = true;
    confirmaInteiroTeor: boolean = false;    

    checkboxVazioOptions: SelectItem[] = [{ label: '', value: false }];
    nivelGovernamentalOptions: Combobox[] = this.gerarCombobox(1, ['Municipal', 'Estadual', 'Federal']);
    tipoDeVinculoOptions: Combobox[] = this.gerarCombobox(1, ['Efetivo', 'Contrato Temporário', 'Celetista']);
    simNaoOptions: Combobox[] = this.gerarCombobox(0, ['Não', 'Sim']);
    orgaosEntidadesExternasOptions: Combobox[];

    constructor(
        private routeDataService: RouteNavigationService,
        private readonly notificationService: NotificationService,
        private route: ActivatedRoute,
        private listaService: ListaService,
        private authenticationService: PMVAuthenticationService,
        private convocacaoService: ConvocacaoService
    ) { super(route); }

    ngOnInit(): void {
        this.loading = true;
        const canActivate = this.authenticationService.isUserLoggedIn();
        if (canActivate) {
        } else {
            this.routeDataService.toAcompanhamentoInscricao();
            return;
        }

        this.getCarregarDadosAcumuloCargo();
    }

    getCarregarDadosAcumuloCargo() {
        this.inscricao = this.routeDataService.getDataDadosCandidatoConvocado();
        if (!this.inscricao) {
            this.routeDataService.toAcompanhamentoInscricao();
            return;
        }

        this.listaService.GetEntidadesExternas().subscribe(
            response => {
                this.orgaosEntidadesExternasOptions = this.filtratLista(response, 0);
            });

        this.carregarDeclaracaoPreenchida();

        this.editalAnoPss = 'Edital ' + this.inscricao.anoNumeroEdital + ' - ' + this.inscricao.cargoFuncao;
        this.cpfCandidato = this.authenticationService.getIdLoged().toString();
        this.nomeCandidato = this.authenticationService.getName().toUpperCase();
        this.cargoFuncaoCandidato = this.inscricao.cargoFuncao;
        this.loading = false;
    }

    gerarCombobox(startIndex: number, lista: string[]): Combobox<number>[] {
        let novoCombo: Combobox[] = [];
        lista.forEach(item => {
            let novoItem: Combobox = { id: startIndex, descricao: item };
            novoCombo.push(novoItem);
            startIndex = startIndex + 1;
        });
        return novoCombo;
    }

    filtratLista(listas: Lista[], codigoLista: number): Combobox[] {
        let filtrada = [];
        listas.forEach(element => {
            if (element.t01070_I_CDLISTA == codigoLista) {
                filtrada.push(this.novoItemCombobox(element.t01071_I_CDITEM, element.t01071_S_VALORSTR));
            }
        });
        return filtrada;
    }

    novoItemCombobox(numero: number, texto: string): Combobox<number> {
        const combo = new Combobox();
        combo.descricao = texto;
        combo.id = numero;
        return combo;
    }

    clickConfirmaNaoExerce(): void {
        this.desabilitarExerce = (this.campoConfirmaNaoExerce[0] === false);
        if (this.desabilitarExerce) {
            this.campoConfirmaExerce = false;
        }
    }

    clickConfirmaExerce(): void {        
        this.desabilitarNaoExerce = (this.campoConfirmaExerce != false);
        this.desabilitarCamposExerce = !this.desabilitarNaoExerce;
        // if (this.desabilitarNaoExerce) {
        //     this.campoConfirmaNaoExerce = false;
        // }        
    }

    voltar(): void {
        this.routeDataService.toCandidatoConvocado();
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // tratarData(data: Date): Date {
    //     if (data !== null && data !== undefined) {
    //         return new Date(data);
    //     }
    //     return null;
    // }

    carregarDeclaracaoPreenchida() {
        this.dadosAcumulo = new DadosAcumuloCargo();
        this.dadosAcumulo.numeroInscricao = this.inscricao.nrInscricao;
        this.dadosAcumulo.codigoConcurso = this.inscricao.concurso;

        // this.convocacaoService.postConsultaDeclaracaoAcumuloCargoPreenchida(this.dadosAcumulo)
        //     .subscribe(res => {
        //         if (res.data != undefined) {
                    // this.notificationService.notifySuccess("Declarção de Acúmulo de Cargo já foi preenchida com sucesso.");
                    // this.routeDataService.toCandidatoConvocado();


                    // this.dadosAcumulo = Object.setPrototypeOf(res.data, DadosAcumuloCargo.prototype);
                    // this.dadosAcumulo.dataAdmissao = this.tratarData(this.dadosAcumulo.dataAdmissao);
                    // this.dadosAcumulo.dataAdmissao.getTime();
                    // this.campoDeclaraConhecimento = this.dadosAcumulo.declaracaoConhecimento;
                    // this.confirmaInteiroTeorOptions.forEach(t => t.value = "true");
                    // this.campoDeclaraConhecimento = true;
            //     }
            // }, error => {
            //     throw error;
            // });
    }

    verificaEscalaPlantao(event) {
        this.desabilitarDescricaoEscalaPlantao = (this.valorTrabalhaEscalaPlantao == 0);
    }

    verificaLicencaOuDisponibilidade(event) {
        this.desabilitaCargoEhNomeOrgaoLicenca = (this.valorEstaLicencaDisponibilidade == 0);
    }

    verificarAposentadoria(event) {
        this.desabilitarCamposAposentadoria = (this.valorEstaAposentado == 0);
    }

    handleValidSubmission(form: NgForm): void {
                
        this.dadosAcumulo.declaracaoConhecimento = (this.campoDeclaraConhecimento[0] === false);

        if (this.valorTrabalhaEscalaPlantao != undefined) {
            this.dadosAcumulo.trabalhaEscalaPlantao = (this.valorTrabalhaEscalaPlantao == 1);
        }
        if (this.valorEstaLicencaDisponibilidade != undefined) {
            this.dadosAcumulo.estaLicencaDisponibilidade = (this.valorEstaLicencaDisponibilidade == 1);
        }
        if (this.valorEstaAposentado != undefined) {
            this.dadosAcumulo.estaAposentado = (this.valorEstaAposentado == 1);
        }
        if (this.valorAposentadoriaInvalidez != undefined) {
            this.dadosAcumulo.aposentadoriaInvalidez = (this.valorAposentadoriaInvalidez == 1);
        }        
        
        this.dadosAcumulo.exerceComercio = (this.campoExerceComercio[0] === false);
        this.dadosAcumulo.acumulaCargo = !this.tratarBooleano(this.campoConfirmaNaoExerce);
        this.dadosAcumulo.numeroInscricao = this.inscricao.nrInscricao;
        this.dadosAcumulo.codigoConcurso = this.inscricao.concurso;

        this.convocacaoService.postDadosAcumuloCargo(this.dadosAcumulo)
            .subscribe(res => {
                if (res.data == undefined) {
                    let contador = 1;
                    this.convocacaoService.TratarErro(res.listaErros).forEach(erro => {
                        this.notificationService.notifyError(erro, 2000 * contador);
                        contador = contador + 1;
                    });
                }
            }, error => {
                throw error;
            });
    }

    tratarBooleano(valorBooleano: boolean): boolean {
        return !(valorBooleano == false || valorBooleano[0] == null);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/acumuloCargo/declaracaoAcumuloCargo.component.ts